<template>
  <div style="width: 100%" class="sectionInfo">
    <div style="padding: 20px">

      <el-button
        type="primary"
        @click="backClick()"
        size="small"
        >返回</el-button
      >

      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="showType = true"
        size="small"
        >添加题目</el-button
      >
      <div class="btnInpput">
        <input
          class="file"
          type="file"
          id="files"
          ref="file"
          accept=".xlsx"
          @change="importExcelConfirm"
        />
        <p v-loading="excelLoading" class="el-icon-upload uploadBtn">
          导入 Excel 题目
        </p>
      </div>
      <el-button
        type="primary"
        @click="initSort"
        size="small"
        icon="el-icon-sort"
        >排序</el-button
      >
      <el-button
        type="danger"
        @click="BatchDelExerciseQuestionInTemplateSection"
        size="small"
        icon="el-icon-delete"
        >批量删除</el-button
      >

      <el-button type="primary" @click="showChangeMarks = true" size="small"
        >修改全部分值</el-button
      >

      <el-button type="primary" @click="updateRedisExerciseTemplate()" size="small"
        >更新服务器试卷</el-button
      >

      <el-table
        :data="question_list"
        v-loading="excelLoading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" width="55">
          <template slot-scope="scope">{{
            scope.row.extra_index ? scope.row.extra_index : scope.$index + 1
          }}</template>
        </el-table-column>
        <el-table-column label="组" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.question_group || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="对应材料" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.question_article || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="题目" width="500">
          <template slot-scope="scope">
            <div v-html="formatContent(scope.row.question_question)"></div>
          </template>
        </el-table-column>
        <el-table-column label="A">
          <template slot-scope="scope">
            <div>
              <div v-html="formatContent(scope.row.question_optionA)"></div>
              <div v-if="scope.row.question_optionA_versionB" class="option-version-b">
                <small>B:</small>
                <div v-html="formatContent(scope.row.question_optionA_versionB)"></div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="B">
          <template slot-scope="scope">
            <div>
              <div v-html="formatContent(scope.row.question_optionB)"></div>
              <div v-if="scope.row.question_optionB_versionB" class="option-version-b">
                <small>B:</small>
                <div v-html="formatContent(scope.row.question_optionB_versionB)"></div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="C">
          <template slot-scope="scope">
            <div>
              <div v-html="formatContent(scope.row.question_optionC)"></div>
              <div v-if="scope.row.question_optionC_versionB" class="option-version-b">
                <small>B:</small>
                <div v-html="formatContent(scope.row.question_optionC_versionB)"></div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="D">
          <template slot-scope="scope">
            <div>
              <div v-html="formatContent(scope.row.question_optionD)"></div>
              <div v-if="scope.row.question_optionD_versionB" class="option-version-b">
                <small>B:</small>
                <div v-html="formatContent(scope.row.question_optionD_versionB)"></div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="E">
          <template slot-scope="scope">
            <div>
              <div v-html="formatContent(scope.row.question_optionE)"></div>
              <div v-if="scope.row.question_optionE_versionB" class="option-version-b">
                <small>B:</small>
                <div v-html="formatContent(scope.row.question_optionE_versionB)"></div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="答案">
          <template slot-scope="scope">
            <div v-html="scope.row.question_answer"></div>
          </template>
        </el-table-column>

        <el-table-column label="分值">
          <template slot-scope="scope">
            <div v-html="scope.row.question_marks"></div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="300px">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="edit(scope.row._id.$id)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click="
                removeExerciseQuestionInTemplateSection(scope.row._id.$id)
              "
              >删除</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="correctSync(scope.row)"
              >同步修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :visible.sync="showType" width="400px">
        <div style="width: 100%; text-align: center">
          <el-button type="primary" size="mini" @click="toNew"
            >直接创建新题</el-button
          >
          <el-button type="primary" size="mini" @click="add"
            >从题库中选择</el-button
          >
        </div>
      </el-dialog>

      <el-dialog title="修改全部分值" :visible.sync="showChangeMarks">
        <el-input
          type="number"
          v-model="change_marks"
          placeholder="请输入分值"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="changeMarks()">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="添加题目" :visible.sync="showAdd">
        <el-table :data="questions_all" height="60vh" v-loading="loading">
          <el-table-column
            label="题目"
            prop="question_question_string"
          ></el-table-column>
          <el-table-column
            label="主题"
            prop="question_subject"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="addExerciseQuestionToTemplateSection(scope.row._id.$id)"
                >添加</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog title="查看题目信息" :visible.sync="showQuestion">
        <el-form :model="currentRow" class="questionForm" label-width="100px">
          <el-form-item label="问题">
            <el-input
              type="textarea"
              :rows="5"
              style="width: 98%"
              v-model="currentRow.question_question_string"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="学科">
            <el-input v-model="currentRow.question_subject" disabled></el-input>
          </el-form-item>
          <el-form-item label="年份">
            <el-input v-model="currentRow.question_year" disabled></el-input>
          </el-form-item>
          <el-form-item label="等级">
            <el-input v-model="currentRow.question_level" disabled></el-input>
          </el-form-item>
          <el-form-item label="考点">
            <el-input
              v-model="currentRow.question_competency"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="组">
            <el-input v-model="currentRow.question_group" disabled></el-input>
          </el-form-item>
          <el-form-item label="对应材料">
            <el-input v-model="currentRow.question_article" disabled></el-input>
          </el-form-item>
          <el-form-item label="选项A-VA">
            <el-input
              v-model="currentRow.question_optionA_string"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="选项A-VB">
            <el-input
              :value="currentRow.question_optionA_versionB_string || currentRow.question_optionA_versionB"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="选项B-VA">
            <el-input
              v-model="currentRow.question_optionB_string"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="选项B-VB">
            <el-input
              :value="currentRow.question_optionB_versionB_string || currentRow.question_optionB_versionB"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="选项C-VA">
            <el-input
              v-model="currentRow.question_optionC_string"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="选项C-VB">
            <el-input
              :value="currentRow.question_optionC_versionB_string || currentRow.question_optionC_versionB"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="选项D-VA">
            <el-input
              v-model="currentRow.question_optionD_string"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="选项D-VB">
            <el-input
              :value="currentRow.question_optionD_versionB_string || currentRow.question_optionD_versionB"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="选项E-VA">
            <el-input
              v-model="currentRow.question_optionE_string"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="选项E-VB">
            <el-input
              :value="currentRow.question_optionE_versionB_string || currentRow.question_optionE_versionB"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="答案">
            <el-input v-model="currentRow.question_answer" disabled></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        :visible.sync="showSort"
        :close-on-click-modal="false"
        @opened="initRowSort"
      >
        <el-table :data="sortedArray" class="sort" height="56vh">
          <el-table-column label="拖拽" width="50px">
            <div class="handle">
              <i class="el-icon-s-unfold" style="font-size: 120%"></i>
            </div>
          </el-table-column>
          <el-table-column
            label="题目"
            prop="question_question_string"
          ></el-table-column>
        </el-table>
        <el-button type="primary" size="medium" @click="submit">确认</el-button>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getExerciseSection,
  addExerciseQuestionToTemplateSection,
  getExerciseQuestions,
  removeExerciseQuestionInTemplateSection,
  resortQuestionsInTemplateSection,
  BatchDelExerciseQuestionInTemplateSection,
  importCsvInTemplate,
  changeSectionQuestionMarks,
  delTemplateRedis
} from '../api/examAdmin'
import Template from './Template.vue'
import { parseQuestionExcel } from '../utils/questionExcel'
import Sortable from 'sortablejs'
export default {
  components: { Template },
  data () {
    return {
      template_id: this.$route.query.template_id,
      section_id: this.$route.query.section_id,
      question_list: [],
      questions_all: [],
      showAdd: false,
      showType: false,
      showQuestion: false,
      currentRow: {},
      loading: false,
      sortedArray: [],
      showSort: false,
      excelLoading: false,
      multipleSelection: [],
      ws: null,
      showChangeMarks: false,
      change_marks: 0
    }
  },
  mounted () {
    this.fetchData()
    this.onConnect()
  },
  methods: {

    formatContent (content) {
      if (!content) {
        return
      }
      content = content.replaceAll('&lt;br&gt;', '<br>')
      // content = content.replace(/\\/g, "")
      return content
    },

    onConnect () {
      this.ws = new WebSocket('wss://team-chat.learningfirst.cn:9000')
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(val)
    },
    batchDele () {},

    backClick () {
      this.$router.go(-1)
    },
    updateRedisExerciseTemplate () {
      delTemplateRedis(this.template_id).then(res => {
        this.$message('更新成功')
      })
    },
    fetchData () {
      this.excelLoading = true
      getExerciseSection(this.section_id).then((res) => {
        this.excelLoading = false
        if (res.data.code === 0) {
          this.question_list = res.data.data.questions_item.map((item) => {
            item.question_question = item.question_question.replace(
              /\n/g,
              '<br />'
            )
            return item
          })
        }
      })
    },
    changeMarks () {
      console.log(111, this.section_id)
      console.log(this.change_marks)

      changeSectionQuestionMarks(this.section_id, this.change_marks).then(
        (res) => {
          if (res.data && res.data.code === 0) {
            this.$message({
              message: '已修改',
              type: 'success'
            })
            this.fetchData()
          } else {
            this.$message('已修改')
          }

          this.showChangeMarks = false
        }
      )
    },
    toNew () {
      this.$router.push({
        path: '/addTemplateQuestion',
        query: {
          section_id: this.section_id,
          template_id: this.template_id
        }
      })
    },
    add () {
      this.showAdd = true
      this.loading = true
      getExerciseQuestions().then((res) => {
        if (res.data.code === 0) {
          this.questions_all = res.data.data
          this.loading = false
        }
      })
    },
    addExerciseQuestionToTemplateSection (question_id) {
      addExerciseQuestionToTemplateSection(question_id, this.section_id).then(
        (res) => {
          if (res.data && res.data.code === 0) {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.fetchData()
          } else {
            this.$message('已添加')
          }
        }
      )
    },
    viewQuestion (row) {
      this.currentRow = row
      this.showQuestion = true
    },
    removeExerciseQuestionInTemplateSection (question_id) {
      removeExerciseQuestionInTemplateSection(
        question_id,
        this.section_id
      ).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.fetchData()
        }
      })
    },
    BatchDelExerciseQuestionInTemplateSection () {
      if (this.multipleSelection.length == 0) {
        this.$message.warning('请选择需要删除的题目')
      } else {
        this.$confirm('确定要批量删除吗？', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.multipleSelection = this.multipleSelection.map((m) => {
            const param = {
              question_id: m._id.$id,
              section_id: this.section_id
            }
            return param
          })

          BatchDelExerciseQuestionInTemplateSection({
            templateSection: this.multipleSelection
          }).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.fetchData()
            }
          })
        })
      }
    },
    initRowSort () {
      const sortDiv = document.querySelector(
        '.sort .el-table__body-wrapper tbody'
      )
      Sortable.create(sortDiv, {
        handle: '.handle',
        animation: 150,
        onEnd: ({ oldIndex, newIndex }) => {
          const newArr = JSON.parse(JSON.stringify(this.sortedArray))
          const currRow = newArr.splice(oldIndex, 1)[0]
          newArr.splice(newIndex, 0, currRow)
          // 重新排序完的表格数据
          this.sortedArray = []
          this.$nextTick(function () {
            this.sortedArray = newArr
          })
        }
      })
    },
    initSort () {
      this.showSort = true
      this.sortedArray = JSON.parse(JSON.stringify(this.question_list))
    },
    submit () {
      const questions = this.sortedArray.map((item) => item._id.$id)
      resortQuestionsInTemplateSection(this.section_id, questions).then(
        (res) => {
          console.log(res)
          if (res.data.code === 0) {
            this.$message({
              message: '排序成功',
              type: 'success'
            })
            this.showSort = false
            this.fetchData()
          }
        }
      )
    },
    async importExcelConfirm (event) {
      const file = event.target.files[0]
      let imported = false

      if (!file) {
        return
      }

      this.excelLoading = true

      try {
        const questions = await parseQuestionExcel(file)
        const res = await importCsvInTemplate(questions, this.section_id)

        if (!res.data || res.data.code !== 0) {
          throw new Error((res.data && res.data.msg) || '服务器导入失败，请稍后重试')
        }

        imported = true
        this.$message({
          message: `成功导入 ${questions.length} 道题目`,
          type: 'success'
        })
      } catch (error) {
        this.$message.error(error.message || 'Excel 导入失败，请检查文件后重试')
      } finally {
        event.target.value = ''
        this.excelLoading = false
      }

      if (imported) {
        this.fetchData()
      }
    },
    edit (id) {
      this.$router.push({
        path: '/questionInfo',
        query: {
          question_id: id,
          template_id: this.template_id
        }
      })
    },
    correctSync (e) {
      if (this.ws) {
        const obj = JSON.stringify(e)
        this.ws.send(`correctQuestionSync&${obj}`)
        this.$message.success('同步成功')
      }
    }
  }
}
</script>

<style scoped>
.handle {
  text-align: center;
  cursor: pointer;
}
.uploadBtn {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  padding: 10px 10px;
  border-radius: 2px;
  cursor: pointer;
  margin: 0 10px;

  font-size: 12px;
}
.btnInpput {
  position: relative;
  display: inline-block;
  margin-left: 10px;
}
.file {
  position: absolute;
  width: 89px;
  right: 0;
  height: 33px;
  background: red;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}
.option-version-b {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #dcdfe6;
  color: #606266;
}
</style>
